import { render } from "./ProductosApp.vue?vue&type=template&id=bf22826e"
import script from "./ProductosApp.vue?vue&type=script&lang=js"
export * from "./ProductosApp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__